module.exports = __webpack_public_path__ + "img/dragonfinance.50b64346.png";